import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from './services/http'
import * as api from '@/services/person'   // ✅ 导入 person.js

Vue.prototype.$api = { person: api }       // ✅ 挂载到全局
Vue.prototype.$axios = axios

Vue.config.productionTip = false
Vue.use(ElementUI)

// =======================
// 🕒 自动登出逻辑
// =======================

// 自动登出时间：60分钟（毫秒）
const AUTO_LOGOUT_TIME = 60 * 60 * 1000

// 记录最后活动时间
function resetActiveTime() {
  localStorage.setItem('lastActiveTime', Date.now())
}

// 检查是否超时
function checkTimeout() {
  const last = localStorage.getItem('lastActiveTime')
  const token = localStorage.getItem('token')

  // 有 token 才检查
  if (token && last) {
    const diff = Date.now() - parseInt(last, 10)
    if (diff > AUTO_LOGOUT_TIME) {
      localStorage.removeItem('token')
      localStorage.removeItem('lastActiveTime')
      // 提示并跳转登录页
      alert('登录已过期，请重新登录')
      window.location.href = '/login'
    }
  }
}

// 监听用户操作事件，更新活跃时间
;['click', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach(event => {
  window.addEventListener(event, resetActiveTime)
})

// 初始化时间戳
resetActiveTime()

// 每分钟检测一次
setInterval(checkTimeout, 60 * 1000)

// 浏览器关闭时清除登录状态（可选）
window.addEventListener('beforeunload', () => {
  localStorage.removeItem('token')
  localStorage.removeItem('lastActiveTime')
})

// =======================
// 启动 Vue 实例
// =======================
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
